import { useTranslation } from 'react-i18next';

/** 404: alt som ikke er en kjent rute, også forsiden. */
export default function IkkeFunnet() {
  const { t } = useTranslation();

  return (
    <section>
      <h1 className="mb-2 text-2xl font-semibold">{t('ikkeFunnet.tittel')}</h1>
      <p className="text-slate-700">{t('ikkeFunnet.ingress')}</p>
    </section>
  );
}
